import http from 'hub-http/clients/apiClient';
export async function fetchQuoteSetting(quoteSetting) {
  const data = await http.get(`/inbounddbquotes/v1/quote-settings/setting-value/${quoteSetting}`);
  return data.quoteSettingValue;
}
export function updateQuoteSetting({
  key,
  value
}) {
  return http.put('/inbounddbquotes/v1/quote-settings', {
    data: {
      quoteSettingKey: key,
      value
    }
  });
}